module.exports = __webpack_public_path__ + "assets/img/guiZhouHuiTianZhengLv.a4345ec3.png";